import Vue from 'vue'
import router from '../../router'
import { HTTPServer } from '@/common/js/ajax.js'
import tool from '@/common/js/tool.js'
import $ from 'jquery'
import i18n from '@/locale/i18n'
import store from '@/store'
import { setCodeLiteCookie, getEnv } from '@jcy/shared'
const vues = new Vue()
export const employee = {
  funInit(arr, prepareData) {
    for (var i = 0; i < arr.length; i++) {
      arr[i].type = 0
      if (arr[i].sign === 'gs') {
        arr[i].type = 3
      }
      arr[i].checked = employee.prepareCheckInit(prepareData, arr[i], arr[i].type)
      if (arr[i].childList) {
        if (arr[i].childList.length > 0) {
          employee.funInit(arr[i].childList)
        }
      }
      if (arr[i].users) {
        if (arr[i].users.length > 0) {
          var users = arr[i].users
          for (var j = 0; j < users.length; j++) {
            arr[i].childList.push({
              id: users[j].id,
              name: users[j].employee_name,
              picture: users[j].picture,
              type: 1,
              sign_id: users[j].sign_id,
              value: users[j].value,
              checked: employee.prepareCheckInit(prepareData, users[j], 1)
            })
          }
        }
        delete arr[i].users
      }
    }
  },
  prepareCheckInit(arr, data, type) {
    var bools = false
    for (var i = 0; i < arr.length; i++) {
      if (arr[i].type === type && arr[i].id === data.id) {
        bools = true
      }
    }
    return bools
  },
  conversion(data) {
    var arr = []
    for (var i = 0; i < data.length; i++) {
      arr.push({
        id: data[i].id,
        name: data[i].name,
        picture: data[i].picture,
        type: data[i].type,
        sign_id: data[i].sign_id,
        value: data[i].value,
        post_name: data[i].post_name
      })
    }
    return arr
  },
  refactoring(data) {
    return {
      id: data.id,
      name: data.name,
      picture: data.picture,
      type: data.type,
      sign_id: data.sign_id,
      value: data.value,
      post_name: data.post_name
    }
  },
  /** 更新个人本地信息 */
  /* 获取登录人相关的信息 */
  queryInfo(type, data, callback) {
    HTTPServer.queryInfo({}, 'Loading').then(res => {
      setCodeLiteCookie(getEnv().env, { user: JSON.stringify(res) })
      // res.employeeInfo.complete_step = 1
      // res.employeeInfo.installed = 0
      // res.employeeInfo.app_tab = 1

      const employeeInfo = res.employeeInfo
      const roleTypeVal = String(employeeInfo.role_type).split(',').map(Number)
      // 设置是否为管理员角色标识
      store.commit('SET_USER_INFO', {
        id: employeeInfo.id,
        isManagerRole: roleTypeVal.includes(2) || roleTypeVal.includes(3),
        role_id: employeeInfo.role_id,
        role_type: roleTypeVal
      })
      res.employeeInfo.role_type = roleTypeVal
      localStorage.setItem('userInfo', tool.jsonEncrypt(JSON.stringify(res))) // 2021-10-25 加密个人信息);
      localStorage.setItem('language', employeeInfo.lang || 'zh')
      window._$i18n.locale = employeeInfo.lang || 'zh'
      let setting = employeeInfo.setting ? JSON.parse(employeeInfo.setting) : {}
      localStorage.setItem('listLayoutStyle', setting.navigation || 6)
      localStorage.setItem('detailsLayoutStyle', setting.details || 1)
      vues.$bus.emit('overloadEmployee', true)

      if (type === 'auth_token') {
        if (callback) callback(res)
        return true
      }
      if (type === 'reload') {
        location.reload()
      } else if (type === 'frontend') {
        if (data === 'login') {
          tool.dataembeddingpointSave({
            log_type: 0,
            function_name: i18n.t('login.login'),
            operation_content: i18n.t('login.loginsuccess')
          })
          let tagList = [
            {
              id: 0,
              name: i18n.t('base_common.workbench'), // '工作台',
              active: true,
              type: 'workbench', // 页签类型：
              data: {
                path: '/frontend/workbench', // 跳转路径
                parameter: {} // 携带参数
              }
            }
          ]
          localStorage.setItem('historyTagRecordList', JSON.stringify(tagList))
        }
        setTimeout(() => {
          employee.getReleaseNotice() // 请求通知通告
        }, 100)
        router.push({ path: '/frontend/workbench' })
      } else if (type === 'assistant') {
        // 小助手
        if (data.bean_name === 'attendance') {
          // 考勤
          tool.changeHistorytag({ english_name: 'attendance' })
          router.push({ name: 'Attendance', params: { type: data.type } })
        } else {
          tool.changeHistorytag({ english_name: 'assistant' })
          router.push({
            name: 'Assistant',
            query: { id: data.id },
            params: { data: data, form: 'wechat' }
          })
        }
      }
      // 初始化华巨臣订阅信息（注意：其它项目请注释）
      setTimeout(() => {
        if (window.hjcConfig) {
          tool.initHjcCallback(res.employeeInfo.emid.split('HJCZX')[1]) // 正式
        }
        // tool.initHjcCallback('60001') // 测试用
      }, 2000)
      // 获取考勤管理员
      this.attenFindAllSetting()
      this.getSocialInsuranceSetting()
    })
  },
  // 获取薪酬管理员
  getSocialInsuranceSetting() {
    HTTPServer.getSocialInsuranceSetting({}, false).then(res => {
      let user = tool.decryptMoney(localStorage.getItem('userInfo'))
      let roles = res.admin_arr ? JSON.parse(res.admin_arr) : []
      let arr1 = []
      roles.map(v => {
        arr1.push(v.value)
      })
      let role1 = user.departmentInfo.some(item => {
        return arr1.includes('0-' + item.id)
      })
      let role2 =
        arr1.includes('1-' + user.employeeInfo.id) ||
        arr1.includes('2-' + user.employeeInfo.role_id)
      localStorage.setItem('isSalaryManager', role1 || role2)
    })
  },
  // 获取考勤管理员
  attenFindAllSetting() {
    HTTPServer.attenFindAllSetting({}, false).then(res => {
      let user = tool.decryptMoney(localStorage.getItem('userInfo'))
      let roles = res.attendance_admin ? JSON.parse(res.attendance_admin) : []
      let arr1 = []
      roles.map(v => {
        arr1.push(v.value)
      })
      let role1 = user.departmentInfo.some(item => {
        return arr1.includes('0-' + item.id)
      })
      let role2 =
        arr1.includes('1-' + user.employeeInfo.id) ||
        arr1.includes('2-' + user.employeeInfo.role_id)
      localStorage.setItem('isAttenManager', role1 || role2)
    })
  },
  // 获取平台消息
  getReleaseNotice() {
    let time = new Date().getTime()
    let noDay = tool.formatDate(time, 'yyyy-MM-dd')
    let user = tool.decryptMoney(localStorage.getItem('userInfo'))
    // let user = JSON.parse(localStorage.getItem('userInfo'))
    let account = user.employeeInfo.phone
    let obj = ''
    let releaseNotice = localStorage.getItem('releaseNotice')
      ? JSON.parse(localStorage.getItem('releaseNotice'))
      : ''
    if (releaseNotice && releaseNotice.time !== noDay) {
      releaseNotice = ''
    } else {
      obj = releaseNotice
    }
    if (releaseNotice) {
      if (releaseNotice.time === noDay && !releaseNotice[account]) {
        obj.time = noDay
        obj[account] = 1
      } else if (releaseNotice.time === noDay && releaseNotice[account] < 2) {
        obj.time = noDay
        obj[account] = 2
      } else {
        obj = ''
      }
    } else {
      obj = { time: noDay }
      obj[account] = 1
    }
    if (obj) {
      HTTPServer.getReleaseNotice({}, '').then(res => {
        let arr = []
        res.map(v => {
          if (v.start_time && v.start_time <= time && v.end_time >= time) {
            v.dialog = true
            arr.push(v)
          }
        })
        if (arr.length >= 0) {
          vues.$bus.emit('get-release-notice', arr)
          localStorage.setItem('releaseNotice', JSON.stringify(obj))
        }
      })
    }
  },
  nodeExpand(tag1, tag2, tag3, tag4) {
    if (tag1.value === '0-1') {
      $(tag3.$el).parents('.departmentTree')[0].childNodes[0].style.width = tag4 + 'px'
      return
    }
    setTimeout(() => {
      var conetnt = tag3.$el.getElementsByClassName('el-tree-node__content')
      var label = tag3.$el.getElementsByClassName('tree-label')
      var width = tag4
      for (var i = 0; i < conetnt.length; i++) {
        var w = label[i].offsetWidth + 54 + parseInt(conetnt[i].style.paddingLeft)
        if (w > tag4 && w > width) {
          width = w
        }
      }
      $(tag3.$el).parents('.departmentTree')[0].childNodes[0].style.width = width + 9 + 'px'
    }, 50)
  },
  nodeCollapse(tag1, tag2, tag3, tag4) {
    if (tag1.value === '0-1') {
      $(tag3.$el).parents('.departmentTree')[0].childNodes[0].style.width = tag4 + 'px'
      return
    }
    setTimeout(() => {
      var conetnt = tag3.$el.getElementsByClassName('el-tree-node__content')
      var label = tag3.$el.getElementsByClassName('tree-label')
      var width = label[0].offsetWidth + 54 + parseInt(conetnt[0].style.paddingLeft)
      if (width <= tag4) {
        width = tag4
      }
      $(tag3.$el).parents('.departmentTree')[0].childNodes[0].style.width = width + 9 + 'px'
    }, 50)
  }
}
export default employee
